import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AppThunk} from "../store.ts";
import {AxiosError} from "axios";
import {ICategoriesResponseData} from "../models/CategoriesResponse.ts";
import {CategoriesService} from "../services/categories-service.ts";
import {showCustomErrorToast} from "../../utils/customErrorToast.tsx";
import {t} from "i18next";

type  InitialStateType = {
    data: ICategoriesResponseData[] | null
    isLoading:boolean
};

const initialState: InitialStateType = {
    data: null,
    isLoading:false
}

const slice = createSlice({
    name: "categories",
    initialState: initialState,
    reducers: {
        setInitialData: (state: InitialStateType, action: PayloadAction<ICategoriesResponseData[]>) => {
            state.data = action.payload
        },
        setLoading: (state, action:PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
    },
});
export const categoriesReducer = slice.reducer;
export const categoriesActions = slice.actions;

export const getCategoriesDataTC = (): AppThunk<Promise<ICategoriesResponseData[] | void>> =>
    async (dispatch) => {
        dispatch(categoriesActions.setLoading(true));
        try {
            const res = await CategoriesService.fetchCategoriesData();
            dispatch(categoriesActions.setInitialData(res.data))
            return res.data
        } catch (err) {
            if (err instanceof AxiosError)
                showCustomErrorToast(t('errors.categories'), 'main', 'bottom-center')
            throw err;
        }
        finally {
            dispatch(categoriesActions.setLoading(false));
        }
    };